import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  settingDialog: false,
  type: null
}

// getters
export const getters = {
  settingDialog: state => state.settingDialog,
  type: state => state.type
}

// mutations
export const mutations = {
  [types.SHOW_SETTINGDIALOG] (state, type) {
    state.settingDialog = true
    state.type = type
  },
  
  [types.HIDE_SETTINGDIALOG] (state) {
    state.settingDialog = false
  },
}

// actions
export const actions = {
  showSettingDialog ({ commit }, payload) {
    commit(types.SHOW_SETTINGDIALOG, payload)
  },
  
  hideSettingDialog ({ commit }) {
    commit(types.HIDE_SETTINGDIALOG)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dialog.js